import DebugService from "./DebugService";
import RecommendationApiService from "./RecommendationApiService";
import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";

/**
 * @description Dashboard Service
 */
const DashboardService = {

  apiData: {},
  advisoryApiData: {},
  computeOptimizerApiData: [],
  // typeList: ['EC2, EBS, RDS, S3'], --NOT In Use--
  totalMonthlyCost: 0,
  totalMonthlySaving: 0,

  EC2MonthlyCost: 0,
  EC2MonthlyRecommendedCost: 0,

  EBSMonthlyCost: 0,
  EBSMonthlyRecommendedCost: 0,

  RDSMonthlyCost: 0,
  RDSMonthlyRecommendedCost: 0,

  S3MonthlyCost: 0,
  S3MonthlyRecommendedCost: 0,

  VMMonthlyCost: 0,
  VMMonthlyRecommendedCost: 0,

  ManagedDiskMonthlyCost: 0,
  ManagedDiskMonthlyRecommendedCost: 0,

  PublicIPMonthlyCost: 0,
  PublicIPMonthlyRecommendedCost: 0,

  ManagedDiskSnapshotMonthlyCost: 0,
  ManagedDiskSnapshotMonthlyRecommendedCost: 0,

  async fetchData(selectedAccount, selectedDate, isForceRefresh = false) {
    try {
      await RecommendationApiService.getData(selectedAccount, 'ALL_SERVICES', selectedDate, null, isForceRefresh)
        .then(res => {
          const data = res['data'] ?? {}
          this.apiData = data
          DebugService.log(`Dashboard Service: Data`, data)

          if (!Object.keys(data).length) {
            DebugService.log(`Dashboard Service: Data is empty`, data)

            this.totalMonthlyCost = 0
            this.totalMonthlySaving = 0
            this.EC2MonthlyCost = 0
            this.EC2MonthlyRecommendedCost = 0
            this.EBSMonthlyCost = 0
            this.EBSMonthlyRecommendedCost = 0
            this.RDSMonthlyCost = 0
            this.RDSMonthlyRecommendedCost = 0
            this.S3MonthlyCost = 0
            this.S3MonthlyRecommendedCost = 0
          } else {

            // Fetch Forecast cost data
            this.totalMonthlyCost = data['FORECAST_COST'] ? data['FORECAST_COST']['forecastedCostValue'] : 0

            this.EC2MonthlyCost = data['EC2'] ? (data['EC2']['currentCost'] ?? data['EC2']['currentOnDemandMonthlyPriceValue']) : 0
            this.EC2MonthlyRecommendedCost = data['EC2'] ? (data['EC2']['recommendedCost'] ?? data['EC2']['recommendedOnDemandMonthlyPriceValue']) : 0

            this.RDSMonthlyCost = data['RDS'] ? (data['RDS']['currentCost'] ?? data['RDS']['currentOnDemandMonthlyPriceValue']) : 0
            this.RDSMonthlyRecommendedCost = data['RDS'] ? (data['RDS']['recommendedCost'] ?? data['RDS']['recommendedOnDemandMonthlyPriceValue']) : 0

            this.EBSMonthlyCost = data['EBS'] ? (data['EBS']['currentCost'] ?? data['EBS']['currentOnDemandMonthlyPriceValue']) : 0
            this.EBSMonthlyRecommendedCost = data['EBS'] ? (data['EBS']['recommendedCost'] ?? data['EBS']['recommendedOnDemandMonthlyPriceValue']) : 0

            const awsRecommendations = Object.entries(data).filter(([k, v]) => k !== 'FORECAST_COST')
            this.totalMonthlySaving = 0
            for (let i = 0; i < awsRecommendations.length; i++) {
              this.totalMonthlySaving += awsRecommendations[i][1]['savingCost'] ?? 0
            }

            // const totalCost = this.EC2MonthlyCost + this.RDSMonthlyCost + this.EBSMonthlyCost
            // const totalRecommendedCost = this.EC2MonthlyRecommendedCost + this.RDSMonthlyRecommendedCost + this.EBSMonthlyRecommendedCost

            // Fetch total savings
            // this.totalMonthlySaving = totalCost - totalRecommendedCost
          }
        })
        .finally(() => { })

    } catch (error) {
      DebugService.error(`Dashboard Service: `)
    }
  },

  async fetchAzureData(selectedAccount, selectedDate, isForceRefresh = false) {
    try {
      const requestBody = {
        userId: '',
        type: 'ALL_SERVICES',
        userAccountId: selectedAccount,
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          requestBody['userId'] = parseToJson['userId']
        }
      }

      if (selectedDate) {
        requestBody['date'] = selectedDate
      }

      await RecommendationApiService.getAzureData(requestBody)
        .then(res => {
          const data = res['data'] ?? {}
          this.apiData = data
          DebugService.log(`Dashboard Service: Data`, data)

          if (!Object.keys(data).length) {
            DebugService.log(`Dashboard Service: Data is empty`, data)

            this.totalMonthlyCost = 0
            this.totalMonthlySaving = 0
            // this.EC2MonthlyCost = 0
            // this.EC2MonthlyRecommendedCost = 0
            // this.EBSMonthlyCost = 0
            // this.EBSMonthlyRecommendedCost = 0
            // this.RDSMonthlyCost = 0
            // this.RDSMonthlyRecommendedCost = 0
            // this.S3MonthlyCost = 0
            // this.S3MonthlyRecommendedCost = 0
          } else {

            // Fetch Forecast cost data
            this.totalMonthlyCost = data['FORECAST_COST'] ? data['FORECAST_COST']['forecastedCostValue'] : 0

            this.VMMonthlyCost = data['VM'] ? data['VM']['currentCost'] : 0
            this.VMMonthlyRecommendedCost = data['VM'] ? data['VM']['recommendedCost'] : 0

            this.PublicIPMonthlyCost = data['PUBLIC_IP'] ? data['PUBLIC_IP']['currentCost'] : 0
            this.PublicIPMonthlyRecommendedCost = data['PUBLIC_IP'] ? data['PUBLIC_IP']['recommendedCost'] : 0

            this.ManagedDiskMonthlyCost = data['MANAGED_DISK'] ? data['MANAGED_DISK']['currentCost'] : 0
            this.ManagedDiskMonthlyRecommendedCost = data['MANAGED_DISK'] ? data['MANAGED_DISK']['recommendedCost'] : 0

            const snapshotObj = data['MANAGED_DISK_SNAPSHOT'] || data['MANAGED_DISK_SNAPSHOTS'] || data['MANAGED_DISKS_SNAPSHOT']
            this.ManagedDiskSnapshotMonthlyCost = snapshotObj ? snapshotObj['currentCost'] : 0
            this.ManagedDiskSnapshotMonthlyRecommendedCost = snapshotObj ? snapshotObj['recommendedCost'] : 0

            // const totalCost = this.EC2MonthlyCost + this.RDSMonthlyCost + this.EBSMonthlyCost
            // const totalRecommendedCost = this.EC2MonthlyRecommendedCost + this.RDSMonthlyRecommendedCost + this.EBSMonthlyRecommendedCost

            // // Fetch total savings
            // this.totalMonthlySaving = totalCost - totalRecommendedCost

            const azureRecommendations = Object.entries(data).filter(([k, v]) => k !== 'FORECAST_COST')
            this.totalMonthlySaving = 0
            if (this.totalMonthlyCost !== '0.00' && this.totalMonthlyCost !== 0) {
              for (let i = 0; i < azureRecommendations.length; i++) {
                this.totalMonthlySaving += azureRecommendations[i][1]['savingCost'] ?? 0
              }
            }
          }
        })
        .finally(() => { })

    } catch (error) {
      DebugService.error(`Dashboard Service: `)
    }
  },

  async fetchAzureAdvisoryData(selectedAccount, selectedDate, isForceRefresh = false) {
    try {
      const requestBody = {
        userId: '',
        type: 'AZURE_ADVISORYS',
        userAccountId: selectedAccount,
      }
      if (isForceRefresh) {
        requestBody['isForceRefresh'] = true
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          requestBody['userId'] = parseToJson['userId']
        }
      }

      if (selectedDate) {
        requestBody['date'] = selectedDate
      }

      await RecommendationApiService.getAzureData(requestBody)
        .then(res => {
          const rawData = Array.isArray(res) ? res : (res?.data ?? []);
        
          const flattenedData = rawData.map(item => {
            const { shortDescription, extendedProperties, impactedField, id, category, impact } = item;
            const solution = shortDescription?.solution || shortDescription?.problem || item.solution || '—';

            return {
              id: id || item.recommendationTypeId || item.name,
              category: category || extendedProperties?.recommendationSubCategory || 'Cost',
              impact: impact || 'Medium',
              solution,
              impactedField: impactedField || null,
              ...extendedProperties,
            };
          });
        
          this.advisoryApiData = flattenedData;
          DebugService.log(`Dashboard Service: Flattened Advisory Data`, flattenedData);
        })
        .finally(() => { })
      
    } catch (error) {
      DebugService.error(`Dashboard Service: Error fetching Azure Advisory Data`, error);
    }
  },

  async fetchComputeOptimizerData(selectedAccount, selectedDate, isForceRefresh = false) {
    try {
      await RecommendationApiService.getData(selectedAccount, 'AWS_COMPUTE_OPTIMIZER', selectedDate, null, isForceRefresh)
        .then(res => {
          this.computeOptimizerApiData = res['data'] ?? []
          DebugService.log(`Dashboard Service: AWS Compute Optimizer Data`, this.computeOptimizerApiData)
        })
    } catch (error) {
      DebugService.error(`Dashboard Service: Error fetching AWS Compute Optimizer Data`, error);
    }
  },
  async fetchCostAnomalyData(selectedAccount, selectedDate, isForceRefresh = false) {
  try {
    await RecommendationApiService.getData(
      selectedAccount,
      'ANOMALY_COST',
      selectedDate,
      null,
      isForceRefresh
    ).then(res => {
      this.costAnomalyApiData = res['data'] ?? [];
    });
  } catch (error) {
    DebugService.error(
      `Dashboard Service: Error fetching Cost Anomaly Data`,
      error
    );
  }
},

  // Azure Cost Anomalies — same ANOMALY_COST response shape as AWS
  // (data[0].costIncreaseReport), fetched via the Azure recommendations endpoint.
  async fetchAzureCostAnomalyData(selectedAccount, selectedDate, isForceRefresh = false) {
    try {
      const requestBody = {
        userId: '',
        type: 'ANOMALY_COST',
        userAccountId: selectedAccount,
      }
      if (isForceRefresh) {
        requestBody['isForceRefresh'] = true
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          requestBody['userId'] = parseToJson['userId']
        }
      }

      if (selectedDate) {
        requestBody['date'] = selectedDate
      }

      await RecommendationApiService.getAzureData(requestBody)
        .then(res => {
          this.costAnomalyApiData = res?.['data'] ?? []
        })
    } catch (error) {
      DebugService.error(
        `Dashboard Service: Error fetching Azure Cost Anomaly Data`,
        error
      );
    }
  },

  getAPIData() {
    return this.apiData
  },

  getAdvisoryAPIData() {
    return this.advisoryApiData
  },

  getComputeOptimizerAPIData() {
    return this.computeOptimizerApiData;
  },
  getCostAnomalyAPIData() {
  return this.costAnomalyApiData;
},

  getUnusedResourcesAPIData() {
    return this.unusedResourcesApiData;
  },

  getTotalMonthlyCost() {
    return this.totalMonthlyCost
  },

  getTotalMonthlySaving() {
    return this.totalMonthlySaving
  },

  /**
   * Get EC2 Monthly Saving %
  * @returns 
  */
  getTotalMonthlySavingPercent() {
    if (this.totalMonthlySaving === 0 || this.totalMonthlyCost === '0.00') {
      return 0
    }
    // const percent =  ((this.totalMonthlyCost - this.totalMonthlySaving)/this.totalMonthlyCost)*100
    const percent = (this.totalMonthlySaving / this.totalMonthlyCost) * 100
    return percent.toFixed(2)
  },

  /**
   * Get EC2 Monthly Cost
   * @returns 
   */
  getEC2MonthlyCost() {
    return this.EC2MonthlyCost
  },

  /**
   * Get EC2 Monthly Saving
   * @returns 
   */
  getEC2MonthlySaving() {
    return this.EC2MonthlyCost - this.EC2MonthlyRecommendedCost
  },

  /**
   * Get EBS Monthly Cost
   * @returns 
   */
  getEBSMonthlyCost() {
    return this.EBSMonthlyCost
  },

  /**
   * Get EBS Monthly Saving
   * @returns 
   */
  getEBSMonthlySaving() {
    return this.EBSMonthlyCost - this.EBSMonthlyRecommendedCost
  },

  /**
   * Get RDS Monthly Cost
   * @returns 
   */
  getRDSMonthlyCost() {
    return this.RDSMonthlyCost
  },

  /**
   * Get RDS Monthly Saving
   * @returns 
   */
  getRDSMonthlySaving() {
    return this.RDSMonthlyCost - this.RDSMonthlyRecommendedCost
  },

  /**
   * Get VM Monthly Cost
   * @returns 
   */
  getVMMonthlyCost() {
    return this.VMMonthlyCost
  },

  /**
   * Get VM Monthly Saving
   * @returns 
   */
  getVMMonthlySaving() {
    return this.VMMonthlyCost - this.VMMonthlyRecommendedCost
  },

  /**
   * Get Managed Disk Monthly Cost
   * @returns 
   */
  getManagedDiskMonthlyCost() {
    return this.ManagedDiskMonthlyCost
  },

  /**
   * Get Managed Disk Monthly Saving
   * @returns 
   */
  getManagedDiskMonthlySaving() {
    return this.ManagedDiskMonthlyCost - this.ManagedDiskMonthlyRecommendedCost
  },

  /**
   * Get Public IP Monthly Cost
   * @returns 
   */
  getPublicIPMonthlyCost() {
    return this.PublicIPMonthlyCost
  },

  /**
   * Get Public IP Monthly Saving
   * @returns 
   */
  getPublicIPMonthlySaving() {
    return this.PublicIPMonthlyCost - this.PublicIPMonthlyRecommendedCost
  },

  /**
   * Get Managed Disk Snapshot Monthly Cost
   * @returns 
   */
  getManagedDiskSnapshotMonthlyCost() {
    return this.ManagedDiskSnapshotMonthlyCost
  },

  /**
   * Get Managed Disk Snapshot Monthly Saving
   * @returns 
   */
  getManagedDiskSnapshotMonthlySaving() {
    return this.ManagedDiskSnapshotMonthlyCost - this.ManagedDiskSnapshotMonthlyRecommendedCost
  },
}

export default DashboardService;
